import apiClient from '@src/services/apiClient'
import { submitEventFormPath } from '@hkpca-web/config/apiPaths'

export const submitEventForm = (formData) => {
  return apiClient.post(
    submitEventFormPath,
    formData
  )
}
